import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { zoneActions, zoneSelectors } from '../';
import { ZONE_DEFAULT_FILTERS } from 'utils/constants/zone';

const useZone = zoneFilters => {
  const zone = useSelector(state =>
    zoneSelectors.getZoneListTransformed(state),
  );
  const forceRefresh = useSelector(state =>
    zoneSelectors.getForceRefresh(state),
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (forceRefresh) {
      dispatch(
        zoneActions.fetchGridList({
          filters: zoneFilters || ZONE_DEFAULT_FILTERS,
          fetchAll: true,
        }), // this will fetch all the zones without any limit
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, forceRefresh]);

  return zone;
};

export default useZone;
